import type { KeyboardEvent, SyntheticEvent } from 'react';

export function filterKeyEnter(handler: (e: KeyboardEvent) => void) {
  return (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(e);
    }
  };
}

export function accessibleOnClick(
  handler: (event?: SyntheticEvent) => void,
  role = 'button',
  tabIndex = 0,
  ariaLabel?: string,
) {
  return {
    role,
    tabIndex,
    onKeyDown: filterKeyEnter(handler),
    onClick: handler,
    'aria-label': ariaLabel,
  };
}
